// extracted by mini-css-extract-plugin
export default {"forbiddenPage":"ForbiddenRegion_forbiddenPage","forbidden":"ForbiddenRegion_forbidden","forbiddenDescription":"ForbiddenRegion_forbiddenDescription","close":"ForbiddenRegion_close"};